import {
  ajaxUniGet,
  ajaxUniPostUsingCaptcha,
  ajaxUniPut,
  ajaxUniDelete,
  ajaxLogout,
  ajaxPlatebniBranaPost,
  checkOkStatusInSuccessFunc,
} from './ajaxutils';
import {
  alertCtk,
  alertCtkApiError,
  confirmCtkButtons,
  fillCountries,
} from './utils';
import { deleteUser } from './deleteuser';
import {
  getValue,
  bindValidateHandlers,
  validateProfilePart,
  setErrorMessage,
  clearErrorMessage,
} from './validate';

const jQuery = window.jQuery;
const cnfg_http_mojectk_php_base = window.cnfg_http_mojectk_php_base;

function setPreviewValue(name, value) {
  jQuery('#sum' + name).html(value);
}
function setEditValue(name, value) {
  jQuery('#form' + name).val(value);
}

function setSelectValue(name, value) {
  jQuery('#form' + name + ' option[value="' + value + '"]').attr(
    'selected',
    'selected',
  );
}

// http://localhost/ctk24/ordersum.php?data={%22email%22:%22obor@example.com%22}

function hideAll() {
  hideChangeUserInfo();
  hideProlongCtk24();
  hideChangePassword();
  clearErrorMessage();
}
function cancelAll(event) {
  hideAll();
  event.preventDefault();
}

function showChangePassword(event) {
  console.log('showChangeUserInfo');
  hideAll();
  validateProfilePart('password', false);
  jQuery('#displaypasswdedit').removeClass('inithidden');
  jQuery('#displaypasswdedit').addClass('initvisible');
  jQuery('#displaypasswdpreview').removeClass('initvisible');
  jQuery('#displaypasswdpreview').addClass('inithidden');
  event.preventDefault();
  return false;
}
function hideChangePassword() {
  console.log('hideChangeUserInfo');
  jQuery('#displaypasswdedit').removeClass('initvisible');
  jQuery('#displaypasswdedit').addClass('inithidden');
  jQuery('#displaypasswdpreview').removeClass('inithidden');
  jQuery('#displaypasswdpreview').addClass('initvisible');
}

function showChangeUserInfo(event) {
  console.log('showChangeUserInfo');
  hideAll();
  LoadUserInfoEdit();
  validateProfilePart('fakturace', false);
  jQuery('#displayuserinfopreview').addClass('inithidden');
  jQuery('#displayuserinfopreview').removeClass('initvisible');
  jQuery('#displayuserinfoedit').addClass('initvisible');
  jQuery('#displayuserinfoedit').removeClass('inithidden');
  event.preventDefault();
  return false;
}
function hideChangeUserInfo() {
  console.log('hideChangeUserInfo');
  // LoadUserInfo();
  jQuery('#displayuserinfopreview').removeClass('inithidden');
  jQuery('#displayuserinfopreview').addClass('initvisible');
  jQuery('#displayuserinfoedit').removeClass('initvisible');
  jQuery('#displayuserinfoedit').addClass('inithidden');
}

function showProlongCtk24() {
  console.log('showProlong');
  hideAll();
  validateProfilePart('prolong', false);
  jQuery('#displayproductctk24preview').addClass('inithidden');
  jQuery('#displayproductctk24preview').removeClass('initvisible');
  jQuery('#displayproductctk24edit').addClass('initvisible');
  jQuery('#displayproductctk24oedit').removeClass('inithidden');
  return false;
}

function hideProlongCtk24() {
  console.log('hideProlong');
  jQuery('#displayproductctk24oedit').addClass('inithidden');
  jQuery('#displayproductctk24edit').removeClass('initvisible');
  jQuery('#displayproductctk24preview').removeClass('inithidden');
  jQuery('#displayproductctk24preview').addClass('initvisible');
  return false;
}

export function LoadUserInfo() {
  const data = {};
  const successFunc = (result, textStatus, jqXHR) => {
    if (!checkOkStatusInSuccessFunc(result, textStatus, jqXHR)) {
      return false;
    }
    console.log('load userinfo returned');
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const json = { ...parsed };

    setPreviewValue('company', json.company);
    setPreviewValue('name', json.name);
    setPreviewValue('surname', json.surname);
    setPreviewValue('email', json.email);
    setPreviewValue('phone', json.phone);
    setPreviewValue('street', json.street);
    setPreviewValue('city', json.city);
    setPreviewValue('psc', json.psc);
    setPreviewValue('country', json.country);
    setPreviewValue('ic', json.ic);
    setPreviewValue('dic', json.dic);

    validateProfilePart('fakturace', false);
  };
  ajaxUniGet('LoadUserInfo', data, successFunc);
  return false;
}
export function LoadUserInfoEdit() {
  const data = {};
  const successFunc = (result, textStatus, jqXHR) => {
    if (!checkOkStatusInSuccessFunc(result, textStatus, jqXHR)) {
      return false;
    }
    console.log('load userinfo edit returned');
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const json = { ...parsed };

    setEditValue('company', json.company);
    setEditValue('name', json.name);
    setEditValue('surname', json.surname);
    setEditValue('email', json.email);
    setEditValue('phone', json.phone);
    setEditValue('street', json.street);
    setEditValue('city', json.city);
    setEditValue('psc', json.psc);
    setSelectValue('country', json.country);
    setEditValue('ic', json.ic);
    setEditValue('dic', json.dic);

    setPreviewValue('emailedit', json.email);

    validateProfilePart('fakturace', false);
  };
  ajaxUniGet('LoadUserInfo', data, successFunc);
  return false;
}

function hideWholeSectionsIfNeeded() {
  if (
    window.profileactiveakademie === true &&
    window.profileactivectk24 === true
  ) {
    jQuery('#nasesluzby').hide();
    jQuery('#aktivnisluzby').show();
  }
  if (
    window.profileactiveakademie === false &&
    window.profileactivectk24 === false
  ) {
    jQuery('#nasesluzby').show();
    jQuery('#aktivnisluzby').hide();
  }
}

export function GetActiveOrders() {
  const data = {};
  const successFunc = (result, textStatus, jqXHR) => {
    if (!checkOkStatusInSuccessFunc(result, textStatus, jqXHR)) {
      return false;
    }
    console.log('load GetActiveOrders returned');
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const list = parsed.list;
    let strPayorder = '';
    let strNew = '';
    let strActive = '';
    let strFinished = '';
    let isEmpty = true;
    let isActive = false;
    list
      .filter((it) => it.producttype === 'ctk24')
      .forEach((it) => {
        const json = { ...it };
        // str += '<p';
        if (json.paymentstate === 'new') {
          // nezobrazovat, dokud neprojde zdenkovou platebni branou
        } else if (json.paymentstate === 'payorder') {
          isEmpty = false;
          isActive = true;
          strPayorder += '<p style="color:#e53935">';
          strPayorder +=
            // ': ' +
            json.orderjson.lengthmessage +
            ', ' +
            json.orderjson.pricemessage +
            ', čeká se na zaplacení faktury ';
        } else if (json.productstate === 'active') {
          isEmpty = false;
          isActive = true;
          strActive += '<p style="color:#000">';
          strActive += json.orderjson.lengthmessage;
          strActive +=
            ' - období: ' + json.datestart + ' - ' + json.dateend + '';
          strActive += ', aktivní';
        } else if (json.productstate === 'finished') {
          strFinished += '<p style="color:#aaa">';
          isEmpty = false;
          strFinished += json.orderjson.lengthmessage;
          strFinished +=
            ' - období: ' + json.datestart + ' - ' + json.dateend + '';
          strFinished += ', skončeno';
        } else if (json.productstate === 'new') {
          isEmpty = false;
          isActive = true;
          strNew += '<p style="color:#4caf50">';
          strNew += json.orderjson.lengthmessage;
          strNew += ' - období: ' + json.datestart + ' - ' + json.dateend + '';
          strNew += ', předplaceno';
        }
        str += '</p>';
      });
    // isEmpty = true;
    // isActive = false;
    let str = strActive + strPayorder + strNew + strFinished;
    if (isEmpty) {
      // str += '<p>Momentálně nemáte žádný produkt aktivní.</p>'; // uz nezobrazovat, protoze po akademii uz se presunulo dolu do "nase sluzby"
      window.profileactivectk24 = false;
      jQuery('#inactivectk24').show();
      //jQuery('#activectk24').hide();
      jQuery('#nasesluzby').show();
      jQuery('#activectk24inner').detach().appendTo('#inactivectk24'); // jQuery("#NodesToMove").detach().appendTo('#DestinationContainerNode')
      jQuery('#ctk24showinfo').show();
    } else {
      window.profileactivectk24 = true;
      jQuery('#inactivectk24').hide();
      jQuery('#activectk24').show();
      jQuery('#aktivnisluzby').show();
      jQuery('#ctk24showinfo').hide();
    }
    hideWholeSectionsIfNeeded();
    if (isActive) {
      // str += '<p>Lze prodlouzit.</p>';
      jQuery('#formbuttonsaveprolongctk24').attr(
        'value',
        'Prodloužit ČTK24 News Report',
      );
      jQuery('#formbuttonprolongctk24').attr(
        'value',
        'Prodloužit ČTK24 News Report',
      );
    } else {
      // str += '<p>Lze objednat.</p>';
      jQuery('#formbuttonsaveprolongctk24').attr(
        'value',
        'Objednat ČTK24 News Report',
      );
      jQuery('#formbuttonprolongctk24').attr(
        'value',
        'Objednat ČTK24 News Report',
      );
    }
    // jQuery('#listproducts').html(      '<h2>ČTK24 News Report:</h2>' + str,
    jQuery('#listproducts').html(
      str,
      // +'<h2>Akademie:</h2>'
      // +'<h2>Protext:</h2>',
    );
  };
  ajaxUniGet('LoadOrdersAndProducts', data, successFunc);
  return false;
}

export function saveUserInfo(event) {
  const f = jQuery('#formbuttonsaveuserinfo');
  if (f.hasClass('notusable')) {
    alertCtk(window.ctkerrormessage);
    return false;
  }
  const data = {};
  data.company = getValue('company');
  data.name = getValue('name');
  data.surname = getValue('surname');
  data.phone = getValue('phone');
  data.street = getValue('street');
  data.city = getValue('city');
  data.psc = getValue('psc');
  data.country = getValue('country');
  data.ic = getValue('ic');
  data.dic = getValue('dic');

  const jsondata = JSON.stringify(data);
  console.log('jsondata: ' + jsondata);

  const successFunc = (result, textStatus, jqXHR) => {
    if (!checkOkStatusInSuccessFunc(result, textStatus, jqXHR)) {
      return false;
    }
    console.log('save returned');
    hideChangeUserInfo();
    LoadUserInfo();
  };
  ajaxUniPostUsingCaptcha(
    'UpdateUserInfo',
    data,
    successFunc,
    'updateuserinfo',
  );

  // ajaxUniPost('UpdateUserInfo', data, successFunc);
  event.preventDefault();
  return false;
}
export function savePassword(event) {
  const f = jQuery('#formbuttonsavepasswd');
  if (f.hasClass('notusable')) {
    alertCtk(window.ctkerrormessage);
    return false;
  }
  const data = {};
  data.passwdold = getValue('passwdold');
  data.passwd = getValue('passwd');
  data.passwd2 = getValue('passwd2');

  const jsondata = JSON.stringify(data);
  console.log('jsondata: ' + jsondata);

  const successFunc = (result, textStatus, jqXHR) => {
    if (!checkOkStatusInSuccessFunc(result, textStatus, jqXHR)) {
      return false;
    }
    console.log('save passwd returned');
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const data = { ...parsed };
    if (data.status === 'badOldPassword') {
      setErrorMessage('Špatné původní heslo');
    } else if (data.status === 'ok') {
      setErrorMessage('Heslo změněno');
      setTimeout(() => {
        hideChangePassword();
      }, 2000);
    } else {
      setErrorMessage('Nějaká neočekávaná chyba - možná neběží API');
    }
  };
  ajaxUniPut('ChangePassword', data, successFunc);
  event.preventDefault();
  return false;
}

export function saveProlongCtk24(event) {
  const f = jQuery('#formbuttonsaveprolongctk24');
  if (f.hasClass('notusable')) {
    alertCtk(window.ctkerrormessage);
    return false;
  }

  const data = {};
  data.lengthcode = jQuery('input[name=length]:checked').val();

  const jsondata = JSON.stringify(data);
  console.log('jsondata: ' + jsondata);

  const successFunc = (result, textStatus, jqXHR) => {
    if (!checkOkStatusInSuccessFunc(result, textStatus, jqXHR)) {
      return false;
    }
    console.log('save prolong returned');
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const res = { ...parsed };
    hideProlongCtk24();
    if (res.status === 'unknownError') {
      alertCtkApiError();
      return false;
    }

    const crc = parsed.crc;
    delete res.crc;
    const redirect = cnfg_http_mojectk_php_base + 'final.php';
    const url1 =
      'https://shop.ctk.cz/platba?src=CTK24&redirect=' +
      redirect +
      '&data=' +
      encodeURI(JSON.stringify(res));
    // + '&crc=' +  parsed.crc;
    console.log('url: ' + url1);
    ajaxPlatebniBranaPost(res, crc);
  };
  ajaxUniPut('ProlongCtk24', data, successFunc);
  event.preventDefault();
  return false;
}

export function profileBindHandlers() {
  console.log('profileBindHandlers');
  jQuery('#formbuttonchangepasswd').on('click', showChangePassword);
  jQuery('#formbuttonsavepasswd').on('click', savePassword);
  jQuery('#formbuttonsavepasswdcancel').on('click', cancelAll);
  jQuery('#formbuttonchangeuserinfo').on('click', showChangeUserInfo);
  jQuery('#formbuttonsaveuserinfo').on('click', saveUserInfo);
  jQuery('#formbuttonsaveuserinfocancel').on('click', cancelAll);
  jQuery('#formbuttonprolongctk24').on('click', showProlongCtk24);
  jQuery('#formbuttonsaveprolongctk24').on('click', saveProlongCtk24);
  jQuery('#formbuttonsaveprolongctk24cancel').on('click', cancelAll);
  jQuery('#formdeleteuser').on('click', deleteUser);
  fillCountries();
  bindValidateHandlers();
  LoadUserInfo();
  GetActiveOrders();
  // InitTestEmailCtk();
}

function sendTestEmail(name) {
  const data = { emailtype: name };
  ajaxUniGet('SendTestMailCtk', data, () => {});
  return false;
}
window.sendTestEmail = sendTestEmail;
